<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Revisor Técnico"
          directory="Recomendar Decisión"
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card card-with-shadow border-0 mb-primary">
          <div class="card-body">
            <div class="form-group">
              <label>Recomendación para Toma de Decision</label>
              <app-input
                type="multi-select"
                :list="list"
                :isAnimatedDropdown="true"
                v-model="inputs"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiURL";
import { axiosPatch } from "@/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],

  props: {
    evalTestId: String,
  },

  data() {
    return {
      app_type: "",
      icon: "settings",
      inputs: [],
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: "Anexos",
          component: "recommend-decision-annexes",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Informes Preliminares",
          component: "preliminary-reports",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Instancias y Equipos de Evaluación",
          component: "evaluation-bodies-teams",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      list: [],
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
  },

  watch: {
    inputs: function () {
      this.update();
    },
  },

  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.TECHNICAL_REVIEWER}?tab=Recomendar%20Decisión`;
    },
    data() {
      this.$store.dispatch("getEvalTest");

      this.axiosGet(
        `${actions.TECHNICAL_REVIEWER}/recommendDecision/get?evalTestId=${this.evalTestId}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.list = response.data.decisions;
            this.inputs = response.data.recommendedDecision.map(
              (item) => item.decision_id
            );
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `${actions.TECHNICAL_REVIEWER}/recommendDecision/process?evalTestId=${this.evalTestId}`;
      this.deleteLoader = true;
      axiosPatch(url)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
    },

    update() {
      const url = `${actions.TECHNICAL_REVIEWER}/recommendDecision/set?evalTestId=${this.evalTestId}`;
      this.axiosPut({ url, data: { decisions: this.inputs } }).then(
        (response) => {
          if (response.status == 200) {
            console.log(response.data);
          }
        }
      );
    },
  },
};
</script>
